import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "form-group"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "scrollListContainer"
}
const _hoisted_4 = { class: "scrollListItem selected d-flex justify-content-between" }
const _hoisted_5 = {
  class: "scrollListContainer",
  ref: "scrollListContainer"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "scrollListContainer"
}
const _hoisted_9 = { class: "scrollListItem selected d-flex justify-content-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.readonly)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.label)
          ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(_ctx.label), 1))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("select", {
          class: "form-control",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.roleFilter) = $event))
        }, [
          _cache[3] || (_cache[3] = _createElementVNode("option", { value: "" }, "Filtra per ruolo", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (item) => {
            return (_openBlock(), _createElementBlock("option", { key: item }, _toDisplayString(item), 1))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.roleFilter]
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control",
          placeholder: "Filtra per nome",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event))
        }, null, 512), [
          [_vModelText, _ctx.search]
        ]),
        (_ctx.localValue)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", null, _toDisplayString(_ctx.localValue.name), 1),
                _createElementVNode("span", {
                  class: "pointer fs-10",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.scrollIntoView && _ctx.scrollIntoView(...args)))
                }, _cache[4] || (_cache[4] = [
                  _createElementVNode("i", null, "(trova nella lista)", -1)
                ]))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredUsers, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["scrollListItem pointer", { selected: _ctx.localValue && _ctx.localValue.identifier == item.identifier }]),
              key: i,
              ref_for: true,
              ref: item.identifier,
              onClick: ($event: any) => (_ctx.selectItem(item))
            }, _toDisplayString(item.name) + " - " + _toDisplayString(item.code), 11, _hoisted_6))
          }), 128))
        ], 512)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
        (_ctx.localValue)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", null, _toDisplayString(_ctx.localValue.name), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
}